module.exports = __webpack_public_path__ + "img/dashboard002.39956380.png";